import { QuerySplitState  , QueryProcessState} from './query.model';
import { createAction, props } from '@ngrx/store';


//acciones para QuerySplitState
export const setSplitPageState = createAction('[Query Split] Set Split Page State', props<QuerySplitState>()) ;
export const resetSplit = createAction('[Query Split] Reset');

//acciones para QueryProcess
export const setProcessState = createAction('[Query Process] Set Process Query State', props<QueryProcessState>()) ;
export const resetProcess = createAction('[Query Process] Reset Process' );